import BaseAPI from './BaseAPI';

export default class extends BaseAPI {
  constructor() {
    super(import.meta.env.VITE_SITE_URL + '/changediary');
  }


  admin(params) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/changediary/admin', { params });
  }


  publish(id) {
    return axios.put(import.meta.env.VITE_SITE_URL + `/changediary/publish/${ id }`);
  }


  unpublish(id) {
    return axios.put(import.meta.env.VITE_SITE_URL + `/changediary/unpublish/${ id }`);
  }
}
